"use client";
import { useAuthBaseURL } from "@/hooks/useAuthBaseURL";

const LoginLink = () => {
  const authBaseUrl = useAuthBaseURL();
  return (
    <a
      className="text-primary hover:text-primary underline"
      href={new URL("login", authBaseUrl).toString()}
    >
      Create account
    </a>
  );
};
export default LoginLink;
